import { useNavigate, useSearch } from '@tanstack/react-router';
import { useEffect } from 'react';

export const useArticleModal = () => {
  const search = useSearch({ strict: false });
  const navigate = useNavigate();

  useEffect(() => {
    const uid = search.article;

    if (uid) {
      navigate({
        to: `/learn/home-electrification/${uid}`,
        search: undefined,
        replace: true,
      });
    }
  }, [history, search]);
};
